module.exports = __webpack_public_path__ + "img/001.3f31635e.png";